export const fmt = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(Number(n) || 0);

export const fmtNum = (n) => new Intl.NumberFormat("en-IN").format(Number(n) || 0);

const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
  "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

const twoDigits = (n) => (n < 20 ? ones[n] : tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : ""));
const threeDigits = (n) => {
  const h = Math.floor(n / 100), r = n % 100;
  return (h ? ones[h] + " Hundred" + (r ? " " : "") : "") + (r ? twoDigits(r) : "");
};

export const amountInWords = (amount) => {
  let n = Math.round(Number(amount) || 0);
  if (n === 0) return "Rupees Zero Only";
  const crore = Math.floor(n / 10000000); n %= 10000000;
  const lakh = Math.floor(n / 100000); n %= 100000;
  const thousand = Math.floor(n / 1000); n %= 1000;
  const parts = [];
  if (crore) parts.push(threeDigits(crore) + " Crore");
  if (lakh) parts.push(twoDigits(lakh) + " Lakh");
  if (thousand) parts.push(twoDigits(thousand) + " Thousand");
  if (n) parts.push(threeDigits(n));
  return "Rupees " + parts.join(" ") + " Only";
};

export const today = () => new Date().toISOString().slice(0, 10);

// Pulls a short "ISO 9001:2015"-style code out of the company's own
// certification text (e.g. "An ISO 9001:2015 Certified Company"), so a
// document only ever prints a certification the profile actually declares —
// never a fixed claim baked into the template.
export const isoLabel = (certification) => {
  const m = /ISO\s?\d[\d:]*\d/i.exec(certification || "");
  return m ? m[0].toUpperCase().replace(/^ISO(?!\s)/, "ISO ") : "";
};

export const expiryLabel = (exp) => {
  if (!exp) return "-";
  const [y, m] = exp.split("-");
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${months[parseInt(m, 10) - 1] || m} ${y}`;
};

const GST_STATE_CODES = {
  "01": "Jammu & Kashmir", "02": "Himachal Pradesh", "03": "Punjab", "04": "Chandigarh",
  "05": "Uttarakhand", "06": "Haryana", "07": "Delhi", "08": "Rajasthan", "09": "Uttar Pradesh",
  "10": "Bihar", "11": "Sikkim", "12": "Arunachal Pradesh", "13": "Nagaland", "14": "Manipur",
  "15": "Mizoram", "16": "Tripura", "17": "Meghalaya", "18": "Assam", "19": "West Bengal",
  "20": "Jharkhand", "21": "Odisha", "22": "Chhattisgarh", "23": "Madhya Pradesh", "24": "Gujarat",
  "27": "Maharashtra", "29": "Karnataka", "30": "Goa", "32": "Kerala", "33": "Tamil Nadu",
  "36": "Telangana", "37": "Andhra Pradesh",
};

export const stateFromGstin = (gstin) => {
  if (!gstin || gstin.length < 2) return "";
  return GST_STATE_CODES[gstin.slice(0, 2)] || `State ${gstin.slice(0, 2)}`;
};
